export default "__VITE_ASSET__BWcLrIlo__"